/* GENERATED FILE — do not edit by hand.
 * Source of truth: public/assets/tutorials/<slug>.en.vtt
 * Regenerate: python3 scripts/generate_tutorial_transcripts.py
 * Why checked in: transcripts must be IN the prerendered static HTML
 * (AEO surface) — design doc agent_docs/cel1157_tutorials_hub_design.md §7.3.
 */
const TUTORIAL_TRANSCRIPTS = {
  "ai-employee-dashboards": [
    {
      "t": 0,
      "text": "Your AI employee builds you dashboards, and keeps them fresh. Find them on the employee's page."
    },
    {
      "t": 7,
      "text": "Here's a real one: the marketing overview Aria maintains, right beside the chat."
    },
    {
      "t": 13,
      "text": "Open it full screen, and it's a real board, not a screenshot."
    },
    {
      "t": 18,
      "text": "She doesn't just update the numbers. She reads the trends, spots what's moving, and flags what needs you. It's her dashboard. She owns it."
    },
    {
      "t": 29,
      "text": "See the work, not just the report."
    }
  ],
  "ai-employee-day-one": [
    {
      "t": 0,
      "text": "What does an AI employee actually do on day one? The moment you hire them, they start onboarding themselves."
    },
    {
      "t": 9,
      "text": "They put their starting tasks on your board, so you can watch the work happen."
    },
    {
      "t": 15,
      "text": "They research your company, register their identity, and set up their own email."
    },
    {
      "t": 22,
      "text": "And they finish with a report: what they learned, and the few things they need from you."
    },
    {
      "t": 29,
      "text": "No training, no ramp up. Day one is a working day."
    }
  ],
  "ai-employee-email-inbox": [
    {
      "t": 0,
      "text": "Every AI employee you hire comes with its own email address."
    },
    {
      "t": 6,
      "text": "Find it on the employee's page, right under their name. One click to copy."
    },
    {
      "t": 13,
      "text": "Clients can email your employee directly. Here, a cafe owner writes in about his opening."
    },
    {
      "t": 20,
      "text": "Your employee reads it, replies on its own, and even suggests a call."
    },
    {
      "t": 27,
      "text": "The client sends times, Nova locks one in, like any colleague would."
    },
    {
      "t": 33,
      "text": "And anything that needs you, like sharing this client list, lands on your board."
    },
    {
      "t": 40,
      "text": "One thing you won't see: employees emailing each other. Teammates talk in channels and DMs. Email is for the outside world, and for you."
    },
    {
      "t": 50,
      "text": "A real inbox, a real address, a real employee."
    }
  ],
  "ai-employee-status-updates": [
    {
      "t": 0,
      "text": "Your AI employees don't just answer you. They post their own updates while you're away."
    },
    {
      "t": 7,
      "text": "Kira finished a piece of client work, and posted the update to the channel. Nobody asked her to check in. It's how employees keep the team current."
    },
    {
      "t": 16,
      "text": "Next time you open CellCog, the unread badge is waiting for you."
    },
    {
      "t": 22,
      "text": "Read it, reply in a thread, and she picks your reply up on her next shift."
    },
    {
      "t": 29,
      "text": "A team that works while you're away, and tells you about it."
    }
  ],
  "archive-a-channel": [
    {
      "t": 0,
      "text": "Project finished? Archive its channel."
    },
    {
      "t": 4,
      "text": "Archiving removes the channel from the active list, but keeps every message."
    },
    {
      "t": 10,
      "text": "Nothing is deleted. Browse your archived channels anytime."
    },
    {
      "t": 15,
      "text": "And if the project comes back, restore it in one click, history intact."
    },
    {
      "t": 21,
      "text": "A tidy sidebar, a complete record."
    }
  ],
  "catch-up-on-what-you-missed": [
    {
      "t": 0,
      "text": "Been away? Your workspace shows you exactly what you missed."
    },
    {
      "t": 5,
      "text": "Unread badges mark the channels with something new since your last visit."
    },
    {
      "t": 11,
      "text": "Open one and read from where you left off. Here, Kira posted her progress update while Alex was away."
    },
    {
      "t": 20,
      "text": "Replies stay tucked into threads, so even a busy channel catches you up in seconds, not scrolling."
    },
    {
      "t": 28,
      "text": "Step away for a day. Catch up in a minute."
    }
  ],
  "connect-your-tools": [
    {
      "t": 0,
      "text": "Your AI employees don't just talk about work. They can act inside the tools you already use. It all starts at Connectors."
    },
    {
      "t": 10,
      "text": "There are three ways to connect."
    },
    {
      "t": 12,
      "text": "Attach pulls your files and data into CellCog."
    },
    {
      "t": 16,
      "text": "Delegate brings CellCog into the platforms your team lives in."
    },
    {
      "t": 21,
      "text": "And Empower gives your employees the ability to act on your behalf."
    },
    {
      "t": 27,
      "text": "Connect Google Drive once,"
    },
    {
      "t": 29,
      "text": "and any chat can pick files straight from it."
    },
    {
      "t": 33,
      "text": "Assign a Linear issue, or delegate from your coding agent. Tasks flow in, finished work flows back."
    },
    {
      "t": 42,
      "text": "Empower is the big one."
    },
    {
      "t": 44,
      "text": "Over thirteen hundred apps, with more than twenty thousand tools inside them."
    },
    {
      "t": 49,
      "text": "An app is the service you connect. Tools are the individual actions your employees can take there."
    },
    {
      "t": 56,
      "text": "Connect an app once."
    },
    {
      "t": 59,
      "text": "And you set the guardrails. Auto-approve safe actions, while anything sensitive waits for your approval."
    },
    {
      "t": 66,
      "text": "Need something specific? Just search. Type Google, and every Google tool shows up, ready to connect."
    },
    {
      "t": 74,
      "text": "Then in any chat, the Tools selector decides exactly what this conversation is allowed to touch."
    },
    {
      "t": 81,
      "text": "From there, your employee files the ticket, sends the update, posts the message. Real work, in your real tools, with the guardrails you set."
    }
  ],
  "create-a-channel": [
    {
      "t": 0,
      "text": "Here's how to create a channel for a new project or topic."
    },
    {
      "t": 4,
      "text": "Click the plus next to Channels."
    },
    {
      "t": 9,
      "text": "Give it a name. One field, one decision."
    },
    {
      "t": 14,
      "text": "That's it. Post the kickoff message, and pull in the employees who need it."
    },
    {
      "t": 20,
      "text": "Your new channel is live, and every employee in your org can find it."
    }
  ],
  "delegate-work-in-chat": [
    {
      "t": 0,
      "text": "The task board is how work flows between you and your AI employees. Click Tasks in your sidebar."
    },
    {
      "t": 8,
      "text": "Here's every task across your whole team, organized by status."
    },
    {
      "t": 14,
      "text": "To hand over work, just ask in your employee's chat, like you'd message a colleague."
    },
    {
      "t": 20,
      "text": "Your employee turns it into a task on the board, and picks it up on their next shift."
    },
    {
      "t": 27,
      "text": "Delegation without meetings."
    }
  ],
  "dms-vs-channels": [
    {
      "t": 0,
      "text": "Channels are for topics. Direct messages are for people."
    },
    {
      "t": 5,
      "text": "To start one, click the plus next to Direct Messages in your sidebar."
    },
    {
      "t": 11,
      "text": "Pick one person or several, humans or AI employees. It's private to the people in it."
    },
    {
      "t": 18,
      "text": "Here, Alex pulls both of his employees into one room to coordinate a photo shoot. Each of them picks it up on their next shift."
    },
    {
      "t": 27,
      "text": "And when the answer could help anyone else? Post in a channel instead. Channels keep knowledge shared. DMs keep it personal."
    },
    {
      "t": 37,
      "text": "Talking to people, DM them."
    },
    {
      "t": 41,
      "text": "Talking about a topic, use the channel. One rule, and your workspace stays tidy."
    }
  ],
  "feedback-on-a-task": [
    {
      "t": 0,
      "text": "Feedback belongs on the task. Open any task and leave a comment. Your employee reads it on their next shift."
    },
    {
      "t": 9,
      "text": "Attach files, screenshots, whatever helps."
    },
    {
      "t": 13,
      "text": "The whole conversation stays with the task. Context never gets lost."
    },
    {
      "t": 20,
      "text": "Feedback that lands exactly where the work is."
    }
  ],
  "general-channel": [
    {
      "t": 0,
      "text": "Every workspace starts with one channel the whole org sees: #general."
    },
    {
      "t": 7,
      "text": "It's created for you automatically, and every employee you hire is already in it."
    },
    {
      "t": 13,
      "text": "Post company-wide announcements here. A new client, a new priority, a win worth sharing."
    },
    {
      "t": 21,
      "text": "Every employee sees it on their next shift, and it stays on the record."
    },
    {
      "t": 27,
      "text": "One room where the whole company hears the same thing."
    }
  ],
  "hire-your-first-ai-employee": [
    {
      "t": 0,
      "text": "Hiring an AI employee takes about a minute. Click New AI Employee at the top of your sidebar."
    },
    {
      "t": 8,
      "text": "Describe the role like you'd brief a real hire. Plain language works."
    },
    {
      "t": 14,
      "text": "Pick how they work: on a schedule, or on demand."
    },
    {
      "t": 19,
      "text": "And that's it. Nova joins your team and starts day one on her own."
    },
    {
      "t": 25,
      "text": "From idea to working employee, in one minute."
    }
  ],
  "mention-your-ai-employee": [
    {
      "t": 0,
      "text": "Need an employee on something right now? Mention them."
    },
    {
      "t": 5,
      "text": "Type the at sign in any channel. Pick an employee, a human teammate, or notify everyone at once."
    },
    {
      "t": 13,
      "text": "Mentioning an AI employee wakes them up. Kira comes online, reads the message, and gets to work."
    },
    {
      "t": 21,
      "text": "Here she is a few minutes later, with the update Alex asked for."
    },
    {
      "t": 27,
      "text": "Not urgent? Just write their name in plain text. They'll see it at the start of their next shift, and nothing gets lost."
    },
    {
      "t": 36,
      "text": "Urgent gets attention now. Everything else waits politely."
    }
  ],
  "pick-the-right-mode": [
    {
      "t": 0,
      "text": "Every chat in CellCog runs on two settings: which agent does the work, and how much power it runs with."
    },
    {
      "t": 9,
      "text": "Agent Mode is one agent, working fast in a loop with you. It builds, researches, and iterates every time you give feedback. The right pick for most work."
    },
    {
      "t": 21,
      "text": "Agent Creative is the same agent, tuned for taste. Reach for it when how the work looks and reads matters as much as whether it runs."
    },
    {
      "t": 31,
      "text": "Agent Team puts several agents on one question, from different angles. Then they challenge each other's findings."
    },
    {
      "t": 39,
      "text": "Then pick a tier. Flash runs considerably cheaper, and it's quick. The right pick for easy, everyday tasks."
    },
    {
      "t": 48,
      "text": "Core and Max spend more to think deeper. That's where your serious work should go."
    },
    {
      "t": 55,
      "text": "You can switch between Agent and Creative, or change any tier, mid-chat. It applies from your next message, with nothing lost."
    },
    {
      "t": 63,
      "text": "One conversation, exactly the right depth at every step."
    }
  ],
  "posts-and-threads": [
    {
      "t": 0,
      "text": "Posts and threads keep your team's discussions tidy. Here's how they work."
    },
    {
      "t": 6,
      "text": "Anyone can post an update in a channel. Here, Kira shares progress on a project."
    },
    {
      "t": 13,
      "text": "To respond without cluttering the channel, reply in a thread."
    },
    {
      "t": 18,
      "text": "Replies stay attached to the original post. The channel stays readable."
    },
    {
      "t": 24,
      "text": "Deep dives happen in threads, and every discussion keeps its context."
    }
  ],
  "recurring-tasks": [
    {
      "t": 0,
      "text": "Some work should happen every week. Just tell your employee the rhythm."
    },
    {
      "t": 5,
      "text": "They set it up as a recurring task, and it's on the board with the rest of the work."
    },
    {
      "t": 12,
      "text": "Each time it's done, it re-arms for the next round, and the board shows what's due today."
    },
    {
      "t": 19,
      "text": "Set the rhythm once. The work keeps happening."
    }
  ],
  "schedule-or-on-demand": [
    {
      "t": 0,
      "text": "Your AI employee can work two ways: on a schedule, or only when you say so."
    },
    {
      "t": 8,
      "text": "A schedule means they clock in on their own, like a full time hire."
    },
    {
      "t": 13,
      "text": "On demand means nothing runs until you press start."
    },
    {
      "t": 18,
      "text": "You can always see the mode on the employee's page, right here."
    },
    {
      "t": 24,
      "text": "And you're never locked in. Pause anytime, start a shift anytime, or change the schedule."
    },
    {
      "t": 31,
      "text": "Full control. Nothing runs without you knowing."
    }
  ],
  "shift-handovers-and-memory": [
    {
      "t": 0,
      "text": "AI employees on CellCog remember. Every shift, forever. Work happens in shifts, and at the end of each one, your employee writes a handover for the next."
    },
    {
      "t": 13,
      "text": "So the next shift picks up mid thought. Same employee, same memory."
    },
    {
      "t": 20,
      "text": "Ask about something from last week, and they know."
    },
    {
      "t": 24,
      "text": "That continuity is the difference between a chatbot and an employee."
    }
  ],
  "shift-reports": [
    {
      "t": 0,
      "text": "Every shift ends with a report: what got done, what's next, and what they need from you, in a few lines."
    },
    {
      "t": 8,
      "text": "Delivered right in the chat, so you catch up in seconds."
    },
    {
      "t": 13,
      "text": "Never wonder what your employee did today."
    }
  ],
  "waiting-on-you-lane": [
    {
      "t": 0,
      "text": "Sometimes your employee needs something only you can give: an approval, an account, a decision. That task lands in the Waiting on you lane."
    },
    {
      "t": 12,
      "text": "Open it, and you'll see exactly what they need, and why."
    },
    {
      "t": 17,
      "text": "Answer it, and they take it from there on their next shift."
    },
    {
      "t": 22,
      "text": "Your employee never stays stuck, and you never get spammed."
    }
  ]
};

export default TUTORIAL_TRANSCRIPTS;
